import { AbsoluteFill, Img, interpolate, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
import './assets/css/Especs.css'
import { useEffect } from "react";

interface SeccionInterface {
	buttonText: string,
	buttonLink: string,
	title: string,
	text: string,
	textAlt: string
}

export const QuieroPlanSection = ({ buttonText, buttonLink, title, text, textAlt }: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps } = useVideoConfig();
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);
	const scaleSection = spring({
		fps,
		frame,
		config: { damping: 400, stiffness: 400 },
		from: 1,
		to: 2,
		delay: (durationInFrames - 8)
	});
	const blurSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 10,
		delay: (durationInFrames - 8)
	});

	// ? PHONE ANIMATION
	const translateBoxPhone = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 100,
		to: 0,
		delay: 0
	});

	// ? NOTIFICACION
	const widthNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 300,
		to: 720,
		delay: 15
	});
	const opacityNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 15
	});

	const iconoScaleNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 35
	});

	const titleTranslateNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 20,
		to: 0,
		delay: 40
	});
	const titleOpacityNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 40
	});
	const title2TranslateNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -20,
		to: 0,
		delay: 45
	});
	const title2OpacityNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 45
	});

	const timeTranslateNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -20,
		to: 0,
		delay: 45
	});
	const timeOpacityNotificacion = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 45
	});

	// ? BOX ANIMATION

	const boxTranslate = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 60
	});
	const boxWidth = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 340,
		to: 550,
		delay: 60
	});
	const boxOpacity = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 60
	});

	const boxTextOpacity = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 70
	});

	// ? HAND ANIMATION

	const handTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 700,
		to: 0,
		delay: 80
	});
	const handRotate1 = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 8,
		to: 8,
		delay: 80
	});
	const handRotate2 = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 8,
		delay: 140
	});

	const handRotate = interpolate(
		frame,
		[80, 140, 141],
		[
			handRotate1,
			0,
			handRotate2
		],
		{
			extrapolateRight: 'clamp',
			extrapolateLeft: 'clamp'
		}
	);

	return (
		<AbsoluteFill style={{
			filter: (blurSection > 0) ? `blur(${blurSection}px)` : '',
			transform: `scale(${scaleSection})`
		}}>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D"
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/10_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="phone" style={{
					position: "absolute",
					bottom: -30,
					left: 130,
					transform: `translateY(${translateBoxPhone}%)`,
				}}>
					<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/11_PHONE-2.png")} style={{
						width: "100%",
						maxWidth: "1000px"
					}} />
					<div className="overlay" style={{
						backgroundColor: "#1c0303a1",
						position: "absolute",
						content: "",
						width: 756,
						height: 870,
						left: "50%",
						bottom: 0,
						borderRadius: "115px 115px 0 0",
						transform: "translateX(-50%)"
					}}></div>
					<div className="notificacion" style={{
						backgroundColor: "#E0E0E0",
						position: "absolute",
						left: 136,
						bottom: 230,
						padding: "1rem",
						display: "flex",
						gap: 20,
						textWrap: "nowrap",
						opacity: opacityNotificacion,
						width: widthNotificacion,
						borderRadius: 30,
						alignItems: "center",
					}}>
						<div className="time" style={{
							position: "absolute",
							color: "#808080",
							right: 20,
							top: 20,
							margin: 0,
							fontSize: 30,
							fontWeight: 500,
							opacity: timeOpacityNotificacion,
							transform: `translateY(${timeTranslateNotificacion}px)`
						}}>{textAlt}</div>
						<div className="icon" style={{
							transform: `scale(${iconoScaleNotificacion})`
						}}>
							<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/miclaro-logo.png")} style={{
								width: "100%",
								maxWidth: "94px",
							}} />
						</div>
						<div className="text">
							<h4 style={{
								color: "#000",
								margin: 0,
								fontSize: 37,
								fontWeight: 500,
								opacity: titleOpacityNotificacion,
								transform: `translateY(${titleTranslateNotificacion}px)`
							}}>{title}</h4>
							<p style={{
								color: "#808080",
								margin: 0,
								fontSize: 30,
								fontWeight: 500,
								opacity: title2OpacityNotificacion,
								transform: `translateY(${title2TranslateNotificacion}px)`
							}}>{text}</p>
						</div>
					</div>
				</div>
				<div className="resumen" style={{
					position: "absolute",
					right: 192,
					top: "50%",
					zIndex: 1,
					width: 550,
					transform: "translateY(-50%)",
				}}>
					<a href={buttonLink} className="cuadro" style={{
						fontWeight: "500",
						margin: "auto",
						zIndex: -1,
						fontSize: 54,
						color: "#fff",
						display: "flex",
						borderRadius: 32,
						textWrap: "nowrap",
						textAlign: "center",
						alignItems: "center",
						padding: "0.5rem 1rem",
						border: "4px solid #fff",
						justifyContent: "center",
						textTransform: "uppercase",
						width: boxWidth,
						opacity: boxOpacity,
						textDecoration: "none",
						transform: `translateX(${boxTranslate}px)`,
						boxShadow: (frame > 140) ? "0 0 0.5rem #fff, inset 0 0 0.5rem #fff, 0 0 2rem #FF0000, inset 0 0 2rem #FF0000, 0 0 4rem #FF0000, inset 0 0 4rem #FF0000" : " 0 0 0 0",
					}}>
						<span style={{
							opacity: boxTextOpacity,
							maxWidth: 335,
							textWrap: "initial"
						}}>{buttonText}</span>
						<div className="circle" style={{
							position: "absolute",
							top: -60,
							left: -60,
							opacity: 0,
						}}>
							<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/circle-white-lines.svg")} style={{
								display: "block",
								width: 140
							}} />
						</div>
					</a>
					<div className="hand" style={{
						position: "absolute",
						top: "60%",
						right: -185,
						transform: `translateY(${handTranslate}px) rotate(${handRotate}deg)`
					}}>
						<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/11_MANO.png")} style={{
							display: "block",
							width: 403
						}} />
					</div>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};